// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upline-tree {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.upline-node-wrapper {
  position: relative;
  padding-top: 8px;
}

.upline-node {
  display: flex;
  align-items: center;
  position: relative;
}

.upline-image {
  width: 32px;
  height: 32px;
  object-fit: cover;
  margin-right: 8px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background-color: #fff;
  z-index: 1;
}

.agent-name {
  font-weight: 500;
  color: #2c3e50;
}

/* Vertical (standing) line */
.line-vertical {
  position: absolute;
  top: -11px;
  left: -12px;
  width: 2px;
  height: 78%;
  background-color: #ccc;
  z-index: 0;
}

/* Horizontal (slipping) line */
.line-horizontal {
  position: absolute;
  top: 50%;
  left: -12px;
  width: 14px;
  height: 2px;
  background-color: #ccc;
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/hierarchy/my-team-details-tree/my-team-details-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA,6BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA,+BAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AACF","sourcesContent":[".upline-tree {\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n}\n\n.upline-node-wrapper {\n  position: relative;\n  padding-top: 8px;\n}\n\n.upline-node {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.upline-image {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  margin-right: 8px;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  background-color: #fff;\n  z-index: 1;\n}\n\n.agent-name {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n/* Vertical (standing) line */\n.line-vertical {\n  position: absolute;\n  top: -11px;\n  left: -12px;\n  width: 2px;\n  height: 78%;\n  background-color: #ccc;\n  z-index: 0;\n}\n\n/* Horizontal (slipping) line */\n.line-horizontal {\n  position: absolute;\n  top: 50%;\n  left: -12px;\n  width: 14px;\n  height: 2px;\n  background-color: #ccc;\n  z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
